let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kZAVi")).then(() => parcelRequire('aMyAY'));